import axiosInstance from '../../axiosInstance';
import {
  setCreateJobError,
  setCreateJobSuccess,
  setPendingJobs,
  setUpdateJobError,
  setCompletedJobs,
  setPendingJobOffers,
  setConfirmedJobs,
  setActiveJobs,
} from './slice';
import {
  selectPendingJobOffers,
  selectPendingJobs,
  selectConfirmedJobs,
  selectActiveJobs,
} from './selector';
import { selectUser } from '../Auth/selector';

export const createJob = (formData, user) => async (dispatch) => {
  // const {
  //   petName,
  //   petType,
  //   passportSubmitted,
  //   driversLicenseSubmitted,
  //   policeCheck,
  //   completedPreviousJobs,
  //   withinTenKms,
  //   ...otherData
  // } = formData;
  // const jobData = {
  //   ...otherData,
  //   petSize: otherData.petSize.value,
  //   currency: otherData.currency.value,
  //   preferences: {
  //     passportSubmitted,
  //     driversLicenseSubmitted,
  //     policeCheck,
  //     completedPreviousJobs,
  //     withinTenKms,
  //   },
  // };
  const data = {
    userId: user._id,
    petName: formData.petName,
    petType: formData.petType.value,
  };
  console.log(data);
  try {
    await axiosInstance.post('job', data);
    dispatch(setCreateJobSuccess(true));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      dispatch(setCreateJobError(errorMsg));
    }
  }
};

export const fetchPendingJobs = () => async (dispatch, getState) => {
  const user = selectUser(getState());
  try {
    const response = await axiosInstance.get('job?state=pending');
    const pendingJobs = response.data.result?.filter(
      job => job.creatorId === user?._id,
    );
    dispatch(setPendingJobs(pendingJobs));
  } catch (err) {
    console.log(err);
  }
};

export const cancelJob = (jobDetails) => async (dispatch, getState) => {
  const data = {
    state: 'cancelled',
    jobId: jobDetails._id,
    creatorId: jobDetails.creatorId,
  };
  try {
    await axiosInstance.put('job', data);
    const updatedPendingJobs = selectPendingJobs(getState()).filter(
      job => job._id !== jobDetails._id,
    );
    dispatch(setPendingJobs(updatedPendingJobs));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      console.log(errorMsg);
      dispatch(setUpdateJobError(errorMsg));
    }
  }
};

export const fetchCompletedJobs = (isPetOwner) => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const response = await axiosInstance.get('job?state=completed');
    const jobs = response.data.result;
    if (isPetOwner) {
      const completedJobs = jobs.filter(job => job.creatorId === user._id);
      dispatch(setCompletedJobs(completedJobs));
    } else {
      const completedJobs = jobs.filter(
        job => job.selectedSitterId === user._id,
      );
      dispatch(setCompletedJobs(completedJobs));
    }
  } catch (err) {
    console.log(err);
  }
};

export const fetchPendingJobOffers = () => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const response = await axiosInstance.get('job?state=pending');
    const pendingOffers = response.data.result?.filter(
      job => job.creatorId !== user?._id,
    );
    dispatch(setPendingJobOffers(pendingOffers));
  } catch (err) {
    console.log(err);
  }
};

export const placeBid = (jobDetails) => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const { _id: jobId } = jobDetails;
    const { _id: sitterId } = user;
    const data = { jobId, sitterId };
    await axiosInstance.post('job/placeBid', data);
    const pendingOffers = selectPendingJobOffers(getState());
    const updatedPendingJobOffers = pendingOffers.map(
      job => (
        job._id !== jobId ?
          job :
          {
            ...job,
            sitterBids: [...job.sitterBids, sitterId],
          }),
    );
    dispatch(setPendingJobOffers(updatedPendingJobOffers));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      dispatch(setUpdateJobError(errorMsg));
    }
  }
};

export const selectSitter = (jobDetails, sitter) => async (dispatch, getState) => {
  try {
    const { _id: jobId } = jobDetails;
    const [sitterId] = sitter;
    const data = { jobId, sitterId };
    await axiosInstance.post('job/selectSitter', data);
    const pendingJobs = selectPendingJobs(getState());
    const updatedPendingJobs = pendingJobs.filter(
      job => job._id !== jobDetails._id,
    );
    dispatch(setPendingJobs(updatedPendingJobs));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      dispatch(setUpdateJobError(errorMsg));
    }
  }
};

export const fetchConfirmedJobs = () => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const response = await axiosInstance.get('job?state=sitter_selected');
    const confirmedJobs = response.data.result?.filter(
      job => job.selectedSitterId === user._id,
    );
    dispatch(setConfirmedJobs(confirmedJobs));
  } catch (err) {
    console.log(err);
  }
};

export const startJob = (jobDetails) => async (dispatch, getState) => {
  try {
    const { _id: jobId, creatorId } = jobDetails;
    const data = { state: 'active', jobId, creatorId };
    await axiosInstance.put('job', data);
    const confirmedJobs = selectConfirmedJobs(getState());
    const updatedConfirmedJobs = confirmedJobs.filter(
      job => job._id !== jobDetails._id,
    );
    dispatch(setConfirmedJobs(updatedConfirmedJobs));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      dispatch(setUpdateJobError(errorMsg));
    }
  }
};

export const fetchActiveJobs = () => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const response = await axiosInstance.get('job?state=active');
    const activeJobs = response.data.result?.filter(
      job => job.creatorId === user._id,
    );
    dispatch(setActiveJobs(activeJobs));
  } catch (err) {
    console.log(err);
  }
};

export const markJobAsComplete = (jobDetails) => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const { _id: jobId } = jobDetails;
    const { _id: creatorId } = user;
    const data = { state: 'completed', jobId, creatorId };
    await axiosInstance.put('job', data);
    const activeJobs = selectActiveJobs(getState());
    const updatedActiveJobs = activeJobs.filter(
      job => job._id !== jobDetails._id,
    );
    dispatch(setActiveJobs(updatedActiveJobs));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      dispatch(setUpdateJobError(errorMsg));
    }
  }
};
